import React, { useState } from "react";
import Header from "../components/Header";
import Header2 from "../components/Header2";
import Footer from "../components/Footer";

import "../assets/css/bootstrap.min.css";
import "../assets/css/style.css";
import "../assets/css/menu.css";
import "../assets/css/vendors.css";
import "../assets/css/icon_fonts/css/all_icons_min.css";
import "../assets/css/custom.css";

const doctorsData = [
  {
    name: "Dr. Priya Sharma",
    qualification: "MBBS, MS - Ophthalmology, Fellowship - Oculoplastic Surgery",
    fee: " FREE Consultation",
    rating: "4.8/5",
    experience: "15 Years Experience",
    location: "2nd Floor, MS Tower, Banjara Hills, Hyderabad",
    phone: "080-6541-7705",
    online: true,
    image: "/assets/img/doctors/doctor1.jpg",
    specialization: "Blepharoplasty Specialist"
  },
  {
    name: "Dr. Anjali Mehta",
    qualification: "MBBS, MS - Ophthalmology, DNB - Oculoplasty",
    fee: " FREE Consultation",
    rating: "4.9/5",
    experience: "12 Years Experience",
    location: "Apurupa Urban, No 201, 2nd Floor, Image Gardens Rd, near Chirec School, Hyderabad",
    phone: "080-6541-7705",
    online: true,
    image: "/assets/img/doctors/doctor2.jpg",
    specialization: "Eyelid Surgery Expert"
  },
  {
    name: "Dr. Rohan Verma",
    qualification: "MBBS, MS - Ophthalmology, MCh - Plastic Surgery",
    fee: " FREE Consultation",
    rating: "4.7/5",
    experience: "14 Years Experience",
    location: "Annapurna Kalyana Mandapam Srinagar Nagar, Dilsukhnagar, Hyderabad",
    phone: "080-6541-7705",
    online: true,
    image: "/assets/img/doctors/doctor1.jpg",
    specialization: "Asian Blepharoplasty Specialist"
  },
  {
    name: "Dr. Sneha Reddy",
    qualification: "MBBS, MS - Ophthalmology, Fellowship - Cosmetic Eyelid Surgery",
    fee: " FREE Consultation",
    rating: "4.6/5",
    experience: "11 Years Experience",
    location: "123 Green Avenue, Banjara Hills, Hyderabad",
    phone: "080-6541-7710",
    online: false,
    image: "/assets/img/doctors/doctor2.jpg",
    specialization: "Upper Blepharoplasty Expert"
  },
  {
    name: "Dr. Kavita Patel",
    qualification: "MBBS, MS - Ophthalmology, MCh - Oculoplastic Surgery",
    fee: " FREE Consultation",
    rating: "4.8/5",
    experience: "16 Years Experience",
    location: "45 Tower Road, Jubilee Hills, Hyderabad",
    phone: "080-6541-7720",
    online: true,
    image: "/assets/img/doctors/doctor1.jpg",
    specialization: "Lower Blepharoplasty Specialist"
  },
  {
    name: "Dr. Arjun Kumar",
    qualification: "MBBS, MS - Ophthalmology, Fellowship - Facial Plastic Surgery",
    fee: "FREE Consultation",
    rating: "4.7/5",
    experience: "13 Years Experience",
    location: "21 MG Road, Hyderabad",
    phone: "080-6541-7730",
    online: false,
    image: "/assets/img/doctors/doctor2.jpg",
    specialization: "Revision Blepharoplasty Expert"
  },
];

const DoctorsSection = () => {
  const [showAll, setShowAll] = useState(false);
  const displayedDoctors = showAll ? doctorsData : doctorsData.slice(0, 6);

  return (
    <div style={{ padding: "80px 20px", backgroundColor: "#f8f9fa" }}>
      <div style={{ maxWidth: "1200px", margin: "0 auto", fontFamily: "'Poppins', sans-serif" }}>
        <div style={{ textAlign: "center", marginBottom: "50px" }}>
          <h2 style={{ fontSize: "42px", fontWeight: "800", color: "#0b1c39", marginBottom: "15px" }}>
            Our <span style={{ color: "#ffcb24" }}>Blepharoplasty Treatment Specialists</span>
          </h2>
          <p style={{ fontSize: "18px", color: "#555", maxWidth: "600px", margin: "0 auto", lineHeight: "1.8" }}>
            Expert surgical care for eyelid rejuvenation with improved vision and natural-looking results.
          </p>
        </div>

        <div style={{ display: "flex", flexWrap: "wrap", gap: "25px", justifyContent: "space-between" }}>
          {displayedDoctors.map((doc, index) => (
            <div
              key={index}
              style={{
                flex: "0 0 calc(33.33% - 17px)",
                backgroundColor: "#fff",
                borderRadius: "16px",
                padding: "25px",
                boxShadow: "0 8px 30px rgba(0,0,0,0.08)",
                display: "flex",
                alignItems: "center",
                gap: "20px",
                border: "1px solid rgba(9,187,175,0.1)",
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-5px)";
                e.currentTarget.style.boxShadow = "0 12px 35px rgba(0,0,0,0.12)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 8px 30px rgba(0,0,0,0.08)";
              }}
            >
              <div style={{ position: "relative", flexShrink: 0 }}>
                <img
                  src={doc.image}
                  alt={doc.name}
                  style={{
                    width: "95px",
                    height: "95px",
                    borderRadius: "50%",
                    objectFit: "cover",
                    border: "3px solid #09bbaf",
                    backgroundColor: "#f8f8f8",
                  }}
                />
                {doc.online && (
                  <span
                    style={{
                      position: "absolute",
                      bottom: "8px",
                      right: "8px",
                      width: "14px",
                      height: "14px",
                      backgroundColor: "#09bbaf",
                      borderRadius: "50%",
                      border: "2px solid #fff",
                    }}
                    title="Online"
                  ></span>
                )}
              </div>

              <div style={{ flex: 1 }}>
                <h3 style={{ fontSize: "18px", fontWeight: "700", color: "#0b1c39", marginBottom: "6px" }}>
                  {doc.name}
                </h3>
                <p style={{ color: "#09bbaf", fontSize: "14px", marginBottom: "6px", fontWeight: "600" }}>
                  {doc.specialization}
                </p>
                <p style={{ color: "#555", fontSize: "14px", marginBottom: "6px" }}>
                  {doc.qualification}
                </p>
                <p style={{ fontWeight: "600", color: "#09bbaf", marginBottom: "6px", fontSize: "15px" }}>
                  {doc.fee}
                </p>
                <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "6px" }}>
                  <span style={{ fontSize: "14px", color: "#555" }}>⭐ {doc.rating}</span>
                  <span style={{ fontSize: "14px", color: "#555" }}>{doc.experience}</span>
                </div>
                <p style={{ fontSize: "13px", color: "#555", display: "flex", alignItems: "flex-start", gap: "6px", marginBottom: "6px", lineHeight: "1.4" }}>
                  📍 {doc.location}
                </p>
                <p style={{ fontSize: "13px", color: "#555", marginBottom: "15px" }}>
                  📞 {doc.phone}
                </p>

                <button
                  style={{
                    padding: "12px 20px",
                    border: "none",
                    borderRadius: "30px",
                    backgroundColor: "#ffcb24",
                    color: "#0b1c39",
                    cursor: "pointer",
                    width: "100%",
                    fontWeight: "600",
                    fontSize: "14px",
                    transition: "background-color 0.3s ease",
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#ffd84f")}
                  onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#ffcb24")}
                >
                  Book Free Consultation
                </button>
              </div>
            </div>
          ))}
        </div>

        {!showAll && doctorsData.length > 6 && (
          <div style={{ textAlign: "center", marginTop: "40px" }}>
            <button
              onClick={() => setShowAll(true)}
              style={{
                padding: "14px 40px",
                fontSize: "16px",
                borderRadius: "12px",
                border: "none",
                backgroundColor: "#09bbaf",
                color: "#fff",
                cursor: "pointer",
                fontWeight: "700",
                boxShadow: "0 8px 25px rgba(9,187,175,0.3)",
                transition: "background-color 0.3s ease",
              }}
              onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#0dcfc2")}
              onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#09bbaf")}
            >
              View More Doctors ▼
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

const BlepharoplastyTreatment = () => {
  const [activeTab, setActiveTab] = useState("overview");

  return (
    <>
      <Header />
      <Header2 />

      {/* Hero Section */}
      <section style={{
        background: "linear-gradient(135deg, #0b1c39 0%, #09bbaf 100%)",
        padding: "160px 0 100px",
        marginTop: "56px",
        color: "white",
        textAlign: "center",
        position: "relative",
        overflow: "hidden"
      }}>
        <div className="container" style={{ position: "relative", zIndex: 2 }}>
          <h1 style={{
            fontSize: "3.5rem",
            fontWeight: "800",
            marginBottom: "20px",
            color: "white"
          }}>
            Advanced Blepharoplasty Treatment
          </h1>
          <p style={{
            fontSize: "1.3rem",
            marginBottom: "30px",
            opacity: "0.9",
            maxWidth: "700px",
            margin: "0 auto 30px",
            lineHeight: "1.6"
          }}>
            Eyelid Rejuvenation with 97% Success Rate. Restore Youthful Eyes and Improve Vision with Precision Surgery.
          </p>
          <div style={{ display: "flex", justifyContent: "center", gap: "20px", flexWrap: "wrap" }}>
            <button style={{
              padding: "15px 35px",
              borderRadius: "30px",
              border: "none",
              backgroundColor: "#ffcb24",
              color: "#0b1c39",
              fontWeight: "700",
              fontSize: "1.1rem",
              cursor: "pointer",
              transition: "all 0.3s ease"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#ffd84f";
              e.currentTarget.style.transform = "translateY(-2px)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "#ffcb24";
              e.currentTarget.style.transform = "translateY(0)";
            }}>
              Book Free Consultation
            </button>
            <button style={{
              padding: "15px 35px",
              borderRadius: "30px",
              border: "2px solid #ffcb24",
              backgroundColor: "transparent",
              color: "#ffcb24",
              fontWeight: "700",
              fontSize: "1.1rem",
              cursor: "pointer",
              transition: "all 0.3s ease"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#ffcb24";
              e.currentTarget.style.color = "#0b1c39";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "transparent";
              e.currentTarget.style.color = "#ffcb24";
            }}>
              Vision Improvement Assessment
            </button>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section style={{ backgroundColor: "#fff", padding: "60px 0", borderBottom: "1px solid #eee" }}>
        <div className="container">
          <div className="row">
            <div className="col-md-3 col-6 text-center">
              <div>
                <h2 style={{ color: "#09bbaf", fontWeight: "800", fontSize: "2.5rem", marginBottom: "10px" }}>97%</h2>
                <p style={{ color: "#0b1c39", fontWeight: "600" }}>Patient Satisfaction</p>
              </div>
            </div>
            <div className="col-md-3 col-6 text-center">
              <div>
                <h2 style={{ color: "#09bbaf", fontWeight: "800", fontSize: "2.5rem", marginBottom: "10px" }}>1-2</h2>
                <p style={{ color: "#0b1c39", fontWeight: "600" }}>Hours Procedure</p>
              </div>
            </div>
            <div className="col-md-3 col-6 text-center">
              <div>
                <h2 style={{ color: "#09bbaf", fontWeight: "800", fontSize: "2.5rem", marginBottom: "10px" }}>7-10</h2>
                <p style={{ color: "#0b1c39", fontWeight: "600" }}>Days Recovery</p>
              </div>
            </div>
            <div className="col-md-3 col-6 text-center">
              <div>
                <h2 style={{ color: "#09bbaf", fontWeight: "800", fontSize: "2.5rem", marginBottom: "10px" }}>15+</h2>
                <p style={{ color: "#0b1c39", fontWeight: "600" }}>Years Expert Team</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Doctors Section */}
      <DoctorsSection />

      {/* Navigation Tabs */}
      <section style={{ backgroundColor: "#fff", padding: "40px 0", borderBottom: "1px solid #eee" }}>
        <div className="container">
          <div style={{ display: "flex", justifyContent: "center", gap: "10px", flexWrap: "wrap" }}>
            {[
              { id: "overview", label: "Overview", icon: "📋" },
              { id: "benefits", label: "Benefits", icon: "✨" },
              { id: "types", label: "Types", icon: "🎯" },
              { id: "procedure", label: "Procedure", icon: "🔬" },
              { id: "recovery", label: "Recovery", icon: "⚕️" },
              { id: "candidates", label: "Candidates", icon: "👥" },
              { id: "faq", label: "FAQ", icon: "❓" }
            ].map(tab => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                style={{
                  padding: "12px 24px",
                  borderRadius: "25px",
                  border: "none",
                  backgroundColor: activeTab === tab.id ? "#09bbaf" : "#f8f9fa",
                  color: activeTab === tab.id ? "white" : "#555",
                  fontWeight: "600",
                  cursor: "pointer",
                  transition: "all 0.3s ease"
                }}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Main Content */}
      <div className="container" style={{ padding: "80px 15px" }}>

        {/* Comprehensive Overview */}
        <section style={{ marginBottom: "80px" }}>
          <div style={{ textAlign: "center", marginBottom: "60px" }}>
            <h2 style={{ fontSize: "36px", fontWeight: "800", color: "#0b1c39", marginBottom: "20px" }}>
              Complete Guide to <span style={{ color: "#09bbaf" }}>Blepharoplasty Treatment</span>
            </h2>
          </div>

          {/* What is Blepharoplasty */}
          <div style={{ marginBottom: "60px" }}>
            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "50px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
              border: "1px solid rgba(9,187,175,0.1)"
            }}>
              <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "30px" }}>
                Understanding Blepharoplasty
              </h3>
              
              <p style={{ color: "#555", lineHeight: "1.8", fontSize: "1.1rem", marginBottom: "25px" }}>
                Blepharoplasty, commonly known as eyelid surgery, is a sophisticated surgical procedure that 
                rejuvenates the appearance of the eyelids by removing excess skin, fat, and muscle. This 
                procedure can be performed on the upper eyelids, lower eyelids, or both to address age-related 
                changes and improve both cosmetic appearance and visual function.
              </p>

              <div className="row">
                <div className="col-md-6">
                  <div style={{
                    backgroundColor: "#f8f9fa",
                    borderRadius: "15px",
                    padding: "25px",
                    borderLeft: "4px solid #09bbaf",
                    marginBottom: "25px"
                  }}>
                    <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px" }}>Functional Benefits</h5>
                    <p style={{ color: "#555", margin: 0 }}>
                      Improves peripheral vision obstructed by drooping upper eyelids, reduces eye fatigue, 
                      and alleviates heaviness caused by excess eyelid tissue affecting daily activities.
                    </p>
                  </div>
                </div>
                <div className="col-md-6">
                  <div style={{
                    backgroundColor: "#f8f9fa",
                    borderRadius: "15px",
                    padding: "25px",
                    borderLeft: "4px solid #ffcb24",
                    marginBottom: "25px"
                  }}>
                    <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px" }}>Aesthetic Benefits</h5>
                    <p style={{ color: "#555", margin: 0 }}>
                      Creates more alert, youthful-looking eyes by eliminating hooded eyelids, reducing 
                      under-eye bags, and smoothing eyelid contours for enhanced facial harmony.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Benefits & Advantages */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Benefits & Advantages of Blepharoplasty
            </h3>

            <div className="row">
              {[
                {
                  title: "Improved Vision", 
                  description: "Restores peripheral vision obstructed by drooping upper eyelids, enhancing daily activities and safety",
                  details: "Medical necessity for significant visual field obstruction"
                },
                {
                  title: "Youthful Appearance", 
                  description: "Eliminates tired, aged appearance by removing excess skin and fat pockets around eyes",
                  details: "Creates more alert and refreshed look"
                },
                {
                  title: "Enhanced Confidence", 
                  description: "Significant improvement in self-esteem and social confidence through refreshed eye appearance",
                  details: "Life-changing psychological benefits"
                },
                {
                  title: "Long-lasting Results", 
                  description: "Provides permanent improvement in eyelid contours that typically lasts 10-15 years",
                  details: "Enduring cosmetic and functional benefits"
                },
                {
                  title: "Minimal Scarring", 
                  description: "Strategic incision placement ensures scars are well-hidden in natural eyelid creases",
                  details: "Scars become virtually invisible over time"
                },
                {
                  title: "Quick Recovery", 
                  description: "Relatively fast recovery with most patients returning to normal activities within 7-10 days",
                  details: "Outpatient procedure with local anesthesia"
                }
              ].map((benefit, index) => (
                <div key={index} className="col-lg-4 col-md-6 mb-4">
                  <div style={{
                    backgroundColor: "#fff",
                    borderRadius: "15px",
                    padding: "25px",
                    boxShadow: "0 8px 25px rgba(0,0,0,0.08)",
                    border: "1px solid rgba(9,187,175,0.1)",
                    height: "100%",
                    transition: "transform 0.3s ease"
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.transform = "translateY(-5px)"}
                  onMouseLeave={(e) => e.currentTarget.style.transform = "translateY(0)"}>
                    <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px", fontSize: "1.2rem" }}>
                      {benefit.title}
                    </h5>
                    <p style={{ color: "#555", fontSize: "1rem", lineHeight: "1.6", marginBottom: "15px" }}>
                      {benefit.description}
                    </p>
                    <div style={{
                      backgroundColor: "#f8f9fa",
                      borderRadius: "8px",
                      padding: "12px",
                      borderLeft: "3px solid #09bbaf"
                    }}>
                      <p style={{ color: "#666", fontSize: "0.9rem", lineHeight: "1.5", margin: 0 }}>
                        {benefit.details}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Blepharoplasty Types & Classification */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Types of Blepharoplasty Procedures
            </h3>

            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "40px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)"
            }}>
              <div className="row">
                {[
                  {
                    type: "Upper Blepharoplasty",
                    description: "Addresses drooping upper eyelids by removing excess skin and fat, improving vision and creating eyelid crease",
                    treatment: "Ideal for hooded eyes and visual field obstruction"
                  },
                  {
                    type: "Lower Blepharoplasty",
                    description: "Targets under-eye bags and puffiness by removing or repositioning fat pads and tightening skin",
                    treatment: "Transconjunctival or external approach options"
                  },
                  {
                    type: "Asian Blepharoplasty",
                    description: "Creates or enhances upper eyelid crease in patients of Asian descent for defined eyelid appearance",
                    treatment: "Specialized technique for ethnic eyelids"
                  },
                  {
                    type: "Transconjunctival Blepharoplasty",
                    description: "Internal approach through lower eyelid for fat removal without external incisions, no visible scarring",
                    treatment: "Ideal for younger patients with fat herniation only"
                  },
                  {
                    type: "Revision Blepharoplasty",
                    description: "Corrects unsatisfactory results from previous eyelid surgeries, more complex procedure",
                    treatment: "Requires expert surgeon with revision experience"
                  },
                  {
                    type: "Combination Blepharoplasty",
                    description: "Upper and lower eyelid surgery performed together for comprehensive periorbital rejuvenation",
                    treatment: "Most comprehensive approach for complete eye rejuvenation"
                  }
                ].map((type, index) => (
                  <div key={index} className="col-lg-6 mb-4">
                    <div style={{
                      backgroundColor: "#f8f9fa",
                      borderRadius: "15px",
                      padding: "25px",
                      border: "2px solid #09bbaf",
                      height: "100%"
                    }}>
                      <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px", fontSize: "1.2rem" }}>
                        {type.type}
                      </h5>
                      <p style={{ color: "#555", fontSize: "1rem", lineHeight: "1.6", marginBottom: "15px" }}>
                        {type.description}
                      </p>
                      <div style={{
                        backgroundColor: "#09bbaf",
                        color: "white",
                        padding: "8px 15px",
                        borderRadius: "20px",
                        display: "inline-block",
                        fontSize: "0.9rem",
                        fontWeight: "600"
                      }}>
                        {type.treatment}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Candidates & Considerations */}
          <div style={{ marginBottom: "60px" }}>
            <div style={{
              backgroundColor: "#0b1c39",
              borderRadius: "20px",
              padding: "50px",
              color: "white"
            }}>
              <h3 style={{ fontSize: "28px", fontWeight: "800", marginBottom: "30px", color: "#ffcb24" }}>
                Ideal Candidates & Important Considerations
              </h3>
              
              <div className="row">
                <div className="col-md-6">
                  <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ color: "#ffcb24", fontWeight: "700", marginBottom: "15px" }}>Good Candidates</h5>
                    <ul style={{ color: "rgba(255,255,255,0.9)", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Healthy individuals with no serious eye conditions</li>
                      <li style={{ marginBottom: "10px" }}>Non-smokers or willing to quit before surgery</li>
                      <li style={{ marginBottom: "10px" }}>Realistic expectations about results</li>
                      <li style={{ marginBottom: "10px" }}>Good skin elasticity with minimal sun damage</li>
                      <li>Individuals with functional visual impairment from droopy eyelids</li>
                    </ul>
                  </div>
                </div>
                <div className="col-md-6">
                  <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ color: "#ffcb24", fontWeight: "700", marginBottom: "15px" }}>Important Considerations</h5>
                    <ul style={{ color: "rgba(255,255,255,0.9)", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Final results take 3-6 months to fully manifest</li>
                      <li style={{ marginBottom: "10px" }}>Temporary swelling, bruising, and dry eyes expected</li>
                      <li style={{ marginBottom: "10px" }}>Contact lens use may be restricted for 2-3 weeks</li>
                      <li style={{ marginBottom: "10px" }}>Sun protection crucial during recovery</li>
                      <li>Possible need for touch-up procedures in complex cases</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Treatment Options */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Comprehensive Treatment Approaches
            </h3>

            <div className="row">
              <div className="col-lg-6 mb-4">
                <div style={{
                  backgroundColor: "#fff",
                  borderRadius: "20px",
                  padding: "40px",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
                  border: "2px solid #09bbaf",
                  height: "100%"
                }}>
                  <h4 style={{ color: "#0b1c39", marginBottom: "25px", fontSize: "24px", fontWeight: "800" }}>
                    Non-Surgical Alternatives
                  </h4>
                  
                  <p style={{ color: "#555", lineHeight: "1.8", marginBottom: "25px" }}>
                    For patients with mild to moderate eyelid concerns or those not ready for surgery, 
                    non-surgical options can provide temporary improvement in eyelid appearance.
                  </p>

                  <div style={{ marginBottom: "25px" }}>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Non-Surgical Options:</h6>
                    <div className="row">
                      <div className="col-6">
                        <ul style={{ color: "#555", paddingLeft: "20px", fontSize: "0.95rem" }}>
                          <li style={{ marginBottom: "8px" }}>Botox for crow's feet</li>
                          <li style={{ marginBottom: "8px" }}>Dermal fillers for tear troughs</li>
                          <li style={{ marginBottom: "8px" }}>Laser skin resurfacing</li>
                        </ul>
                      </div>
                      <div className="col-6">
                        <ul style={{ color: "#555", paddingLeft: "20px", fontSize: "0.95rem" }}>
                          <li style={{ marginBottom: "8px" }}>Radiofrequency treatments</li>
                          <li style={{ marginBottom: "8px" }}>Chemical peels</li>
                          <li style={{ marginBottom: "8px" }}>Platelet-rich plasma (PRP) therapy</li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <div>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Limitations:</h6>
                    <ul style={{ color: "#555", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "8px" }}>Temporary results (6-18 months)</li>
                      <li style={{ marginBottom: "8px" }}>Cannot remove excess skin or fat</li>
                      <li style={{ marginBottom: "8px" }}>Limited improvement for significant drooping</li>
                      <li>Cannot improve visual field obstruction</li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="col-lg-6 mb-4">
                <div style={{
                  backgroundColor: "#fff",
                  borderRadius: "20px",
                  padding: "40px",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
                  border: "2px solid #ffcb24",
                  height: "100%"
                }}>
                  <h4 style={{ color: "#0b1c39", marginBottom: "25px", fontSize: "24px", fontWeight: "800" }}>
                    Surgical Blepharoplasty Options
                  </h4>

                  <div style={{ marginBottom: "25px" }}>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Surgical Techniques:</h6>
                    <ul style={{ color: "#555", paddingLeft: "20px", marginBottom: "25px" }}>
                      <li style={{ marginBottom: "10px" }}>Precision removal of excess skin, muscle, and fat</li>
                      <li style={{ marginBottom: "10px" }}>Local anesthesia with sedation for comfort</li>
                      <li style={{ marginBottom: "10px" }}>1-2 hour procedure time depending on complexity</li>
                      <li style={{ marginBottom: "10px" }}>Hidden incisions in natural eyelid creases</li>
                      <li>Fine sutures removed in 5-7 days</li>
                    </ul>
                  </div>

                  <div style={{ marginBottom: "25px" }}>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Advanced Approaches:</h6>
                    <ul style={{ color: "#555", paddingLeft: "20px", marginBottom: "25px" }}>
                      <li style={{ marginBottom: "10px" }}>Fat preservation and repositioning techniques</li>
                      <li style={{ marginBottom: "10px" }}>Canthopexy for eyelid support</li>
                      <li style={{ marginBottom: "10px" }}>Asian double eyelid creation</li>
                      <li style={{ marginBottom: "10px" }}>Composite techniques addressing multiple layers</li>
                      <li>Customized approach based on ethnic background</li>
                    </ul>
                  </div>

                  <div>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Combination Procedures:</h6>
                    <ul style={{ color: "#555", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Brow lift for comprehensive upper face rejuvenation</li>
                      <li style={{ marginBottom: "10px" }}>Facelift for complete facial rejuvenation</li>
                      <li style={{ marginBottom: "10px" }}>Facial fat grafting for volume restoration</li>
                      <li>Laser skin resurfacing for periorbital skin quality</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Surgical Procedure Timeline */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Surgical Procedure & Recovery Timeline
            </h3>

            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "40px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)"
            }}>
              <div className="row">
                {[
                  {
                    period: "Day 1-3",
                    title: "Initial Recovery",
                    activities: ["Significant swelling and bruising", "Cold compresses applied", "Head elevation during sleep", "Pain management"]
                  },
                  {
                    period: "Day 4-7",
                    title: "Early Healing",
                    activities: ["Bruising begins to fade", "Suture removal (day 5-7)", "Light activities resume", "Swelling reduces gradually"]
                  },
                  {
                    period: "Week 2-4",
                    title: "Intermediate Healing",
                    activities: ["Most bruising resolved", "Return to work and social activities", "Makeup can be applied", "Final contours emerge"]
                  },
                  {
                    period: "Month 2-6",
                    title: "Final Results",
                    activities: ["All swelling resolved", "Scars soften and fade", "Natural appearance achieved", "Complete healing"]
                  }
                ].map((stage, index) => (
                  <div key={index} className="col-lg-3 col-md-6 mb-4">
                    <div style={{
                      backgroundColor: "#f8f9fa",
                      borderRadius: "15px",
                      padding: "25px",
                      textAlign: "center",
                      border: "1px solid rgba(9,187,175,0.2)",
                      height: "100%"
                    }}>
                      <div style={{ 
                        backgroundColor: "#09bbaf", 
                        color: "white", 
                        width: "60px", 
                        height: "60px", 
                        borderRadius: "50%", 
                        display: "flex", 
                        alignItems: "center", 
                        justifyContent: "center", 
                        margin: "0 auto 15px",
                        fontWeight: "700",
                        fontSize: "0.9rem"
                      }}>
                        {stage.period}
                      </div>
                      <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px", fontSize: "1.1rem" }}>
                        {stage.title}
                      </h5>
                      <ul style={{ color: "#555", fontSize: "0.85rem", paddingLeft: "15px", textAlign: "left" }}>
                        {stage.activities.map((activity, idx) => (
                          <li key={idx} style={{ marginBottom: "8px" }}>{activity}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Prevention & Aftercare */}
          <div style={{ marginBottom: "60px" }}>
            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "40px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
              border: "2px solid rgba(255,203,36,0.3)"
            }}>
              <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "30px", textAlign: "center" }}>
                Post-operative Care & Instructions
              </h3>

              <div className="row">
                <div className="col-md-6">
                  <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Immediate Post-op Care</h5>
                    <ul style={{ color: "#555", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Apply cold compresses for 48 hours (20 minutes on, 20 minutes off)</li>
                      <li style={{ marginBottom: "10px" }}>Keep head elevated at 45 degrees while sleeping</li>
                      <li style={{ marginBottom: "10px" }}>Use prescribed antibiotic ointments and eye drops</li>
                      <li>Avoid bending, lifting, and strenuous activities</li>
                    </ul>
                  </div>
                </div>
                <div className="col-md-6">
                  <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Long-term Care</h5>
                    <ul style={{ color: "#555", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Wear sunglasses with UV protection for 6 months</li>
                      <li style={{ marginBottom: "10px" }}>Avoid eye makeup for 2 weeks post-surgery</li>
                      <li style={{ marginBottom: "10px" }}>Use scar management products as directed</li>
                      <li>Attend all follow-up appointments for monitoring</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* FAQ Section */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Frequently Asked Questions
            </h3>

            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "40px",
              boxShadow: "0 10line 30px rgba(0,0,0,0.08)"
            }}>
              {[
                {
                  question: "Is blepharoplasty painful?",
                  answer: "Blepharoplasty is generally not considered a painful procedure. During the surgery, local anesthesia with sedation ensures you're completely comfortable and pain-free. Most patients report minimal discomfort after the procedure, typically described as mild tightness, soreness, or irritation rather than sharp pain. Any post-operative discomfort is usually well-controlled with over-the-counter pain relievers like acetaminophen, and most patients don't require prescription pain medication. The sensation is often compared to having a minor eye irritation or feeling like you've been crying extensively. Cold compresses applied during the first 48 hours significantly reduce both discomfort and swelling. By the third day, most patients report only minor tenderness that resolves completely within the first week. The quick recovery and minimal pain make blepharoplasty one of the most well-tolerated facial cosmetic procedures."
                },
                {
                  question: "How long do blepharoplasty results last?",
                  answer: "Blepharoplasty provides long-lasting results that typically endure for 10-15 years, and in many cases, the improvement is permanent for the specific issues addressed. The excess skin, muscle, and fat removed during surgery do not grow back, so this aspect of the results is permanent. However, it's important to understand that blepharoplasty doesn't stop the natural aging process. Your eyelids will continue to age along with the rest of your face, and you may develop some new laxity or changes over time due to gravity, sun exposure, and genetic factors. Many patients find that even after 15-20 years, their eyelids still look better than they would have without surgery. The longevity of results can be extended with good skincare, sun protection, healthy lifestyle, and occasional non-surgical maintenance treatments. Upper blepharoplasty results tend to last longer than lower blepharoplasty since the lower eyelids are more affected by facial aging and volume loss."
                },
                {
                  question: "When will I see final results after blepharoplasty?",
                  answer: "The timeline for seeing final blepharoplasty results follows a gradual progression. Immediately after surgery, significant swelling and bruising obscure the results. Within 1-2 weeks, about 70-80% of the swelling and bruising resolves, revealing the basic new eyelid contours. By 4-6 weeks, most of the noticeable swelling has diminished, and the results become quite apparent, though the eyelids may still feel somewhat tight or firm. The final refined results typically emerge around the 3-month mark when all residual swelling has completely resolved and the tissues have fully settled. However, subtle refinement continues for up to 6 months as the scars mature and soften, becoming virtually invisible in the natural eyelid creases. It's important to have patience during this process and not judge the results too early, as the final beautiful, natural-looking outcome takes time to fully manifest. Your surgeon will monitor your healing progress through regular follow-up appointments."
                },
                {
                  question: "Can blepharoplasty improve my vision?",
                  answer: "Yes, blepharoplasty can significantly improve vision when excess upper eyelid skin obstructs the visual field. This condition, known as dermatochalasis, causes functional visual impairment where the drooping eyelids block peripheral vision and sometimes even central vision. Patients often unconsciously compensate by raising their eyebrows or tilting their head back to see better, which can lead to forehead strain, headaches, and eye fatigue. Upper blepharoplasty removes this excess tissue, immediately restoring the full visual field. Many patients report remarkable improvements in their ability to see clearly, read, drive, and perform daily activities without visual obstruction. The procedure is often covered by medical insurance when visual field testing demonstrates significant impairment. Even patients without measurable visual field obstruction often experience reduced eye fatigue and improved comfort after surgery due to the removal of heavy, sagging eyelid tissue. Both the functional and quality-of-life improvements make blepharoplasty one of the most rewarding procedures for appropriate candidates."
                },
                {
                  question: "What's the difference between upper and lower blepharoplasty?",
                  answer: "Upper and lower blepharoplasty address different aesthetic and functional concerns in distinct anatomical areas. Upper blepharoplasty focuses on the upper eyelids, primarily removing excess skin and sometimes fat that causes hooding, drooping, and visual obstruction. The goal is to create a more defined eyelid crease, restore the visual field, and create a more alert appearance. Lower blepharoplasty targets the lower eyelids, addressing under-eye bags, puffiness, and skin laxity. This procedure typically involves removing or repositioning fat pads and may include skin tightening. The transconjunctival approach (through the inside of the eyelid) is often used for lower blepharoplasty when only fat removal is needed, leaving no visible scars. Key differences include: Different anatomical focus and techniques; Upper often addresses functional issues, lower is primarily cosmetic; Different recovery patterns; Varying scar placement; Distinct age-related concerns addressed. Many patients benefit from combining both procedures for comprehensive periorbital rejuvenation that addresses aging concerns in both upper and lower eyelids simultaneously."
                }
              ].map((faq, index) => (
                <div key={index} style={{ 
                  marginBottom: "25px",
                  paddingBottom: "25px",
                  borderBottom: index < 4 ? "1px solid #eee" : "none"
                }}>
                  <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "10px" }}>
                    {faq.question}
                  </h5>
                  <p style={{ color: "#555", lineHeight: "1.6", margin: 0 }}>
                    {faq.answer}
                  </p>
                </div>
              ))}
            </div>
          </div>

          {/* Final CTA */}
          <div style={{
            background: "linear-gradient(135deg, #0b1c39 0%, #09bbaf 100%)",
            borderRadius: "20px",
            padding: "60px 40px",
            textAlign: "center",
            color: "white"
          }}>
            <h2 style={{ fontSize: "2.5rem", fontWeight: "800", marginBottom: "20px" }}>
              Ready for Youthful, Refreshed Eyes?
            </h2>
            <p style={{ fontSize: "1.2rem", marginBottom: "30px", opacity: "0.9", maxWidth: "600px", margin: "0 auto 30px" }}>
              Our expert oculoplastic surgeons provide precision blepharoplasty for improved vision and natural-looking eyelid rejuvenation.
            </p>
            <button style={{
              padding: "18px 45px",
              borderRadius: "30px",
              border: "none",
              backgroundColor: "#ffcb24",
              color: "#0b1c39",
              fontWeight: "800",
              fontSize: "1.1rem",
              cursor: "pointer",
              transition: "all 0.3s ease"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#ffd84f";
              e.currentTarget.style.transform = "translateY(-2px)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "#ffcb24";
              e.currentTarget.style.transform = "translateY(0)";
            }}>
              Book FREE Consultation Now
            </button>
            <p style={{ marginTop: "20px", fontSize: "1rem", opacity: "0.8" }}>
              Oculoplastic Surgery: <strong>080-6541-7705</strong> | Ophthalmology: <strong>080-6541-7715</strong>
            </p>
          </div>
        </section>
      </div>

      <Footer />
    </>
  );
};

export default BlepharoplastyTreatment;